import React from "react";
import { DateRange } from "react-date-range";
import { isAfter, isEqual } from "date-fns";
import { Button, Form } from "react-bootstrap";
import { dateFormat, formatCustomDate, getLocalstorage } from "../helper";

// const enhanceWithClickOutside = require("react-click-outside");

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import DayPicker, { DateUtils } from "react-day-picker";
import "react-day-picker/lib/style.css";
import YearMonthFrom from "./YearMonthFrom";
import { Helmet } from "react-helmet";
import rightArrow from "../assets/rightArrow.svg";
import { isEmpty } from "lodash";

class PMIICDateRangePicker extends React.Component {
  inceptionDate = new Date(2013, 0, 1, 0, 0, 0, 0);
  static defaultProps = {
    numberOfMonths: 2
  };

  constructor(props) {
    super(props);
    this.handleDayMouseEnter = this.handleDayMouseEnter.bind(this);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleYearMonthChange = this.handleYearMonthChange.bind(this);
    this.wrapperRef = React.createRef(); // Ref to the picker container
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.state = {
      range: {
        from: props.selectedDate ? props.selectedDate.from : new Date(),
        to: props.selectedDate ? props.selectedDate.to : new Date(),
        enteredTo: null
      },
      fromMonth: new Date(),
      toMonth: new Date(new Date().getFullYear(), new Date().getMonth() + 1),
      month: props.fromMonth,
      selectedDate: props.selectedDate,
      isActive: props.isActive,
      ranges: [
        {
          startDate: props.range ? props.range.startDate : new Date(),
          endDate: props.range ? props.range.endDate : new Date()
        }
      ],
      defaultInceptionDateToggle:
        (props.range && isEqual(props.range.startDate, this.inceptionDate)) ||
        false
    };
  }

  componentDidMount() {
    const { range } = this.state;
    document.addEventListener("mousedown", this.handleClickOutside);

    if (range.from && range.to) {
      const fromMonth = new Date(range.from);
      const toMonth = new Date(range.to);

      const isSameMonth =
        fromMonth.getFullYear() === toMonth.getFullYear() &&
        fromMonth.getMonth() === toMonth.getMonth();

      this.setState({
        fromMonth,
        toMonth: isSameMonth
          ? new Date(fromMonth.getFullYear(), fromMonth.getMonth() + 1)
          : toMonth
      });
    } else if (range.from) {
      const fromMonth = new Date(range.from);
      this.setState({
        fromMonth,
        toMonth: new Date(fromMonth.getFullYear(), fromMonth.getMonth() + 1)
      });
    } else {
      const today = new Date();
      this.setState({
        fromMonth: today,
        toMonth: new Date(today.getFullYear(), today.getMonth() + 1)
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (
      this.wrapperRef.current &&
      !this.wrapperRef.current.contains(event.target)
    ) {
      if (!isEmpty(this.props.fromToDate)) {
        this.setState({
          range: {
            from: new Date(this.props.fromToDate.start),
            to: this.props.fromToDate.end
              ? new Date(this.props.fromToDate.end)
              : new Date(this.props.fromToDate.start),
            enteredTo: null
          },
          fromMonth: new Date(this.props.fromToDate.start),
          toMonth: this.props.fromToDate.end
            ? new Date(this.props.fromToDate.end)
            : this.props.fromToDate.start
            ? new Date(
                this.props.fromToDate.start.getFullYear(),
                this.props.fromToDate.start.getMonth() + 1
              )
            : new Date(new Date().getFullYear(), new Date().getMonth() + 1)
        });
      } else {
        this.setState({
          range: {
            from: new Date(),
            to: new Date(),
            enteredTo: null
          },
          fromMonth: new Date(),
          toMonth: new Date(new Date().getFullYear(), new Date().getMonth() + 1)
        });
      }

      if (typeof this.props.handleClose === "function") {
        this.props.handleClose();
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedDate } = this.props;

    const isSameMonth =
      selectedDate &&
      selectedDate.from &&
      selectedDate &&
      selectedDate.to &&
      new Date(selectedDate.from).getMonth() ===
        new Date(selectedDate.to).getMonth() &&
      new Date(selectedDate.from).getFullYear() ===
        new Date(selectedDate.to).getFullYear();

    const propsMonthFromA =
      selectedDate && selectedDate.from
        ? new Date(selectedDate.from)
        : new Date();

    const propsMonthToA =
      selectedDate && selectedDate.to && !isSameMonth
        ? new Date(selectedDate.to)
        : new Date(
            propsMonthFromA.getFullYear(),
            propsMonthFromA.getMonth() + 1
          );

    if (selectedDate !== prevProps.selectedDate && selectedDate != null) {
      const from = new Date(selectedDate.from);
      const to = selectedDate.to ? new Date(selectedDate.to) : from;
      this.setState({
        range: { from, to, enteredTo: null },
        fromMonth: propsMonthFromA,
        toMonth: propsMonthToA,
        isActive: this.props.isActive,
        lastAppliedRange: { from, to }
      });
    } else if (prevProps.selectedDate != null && selectedDate == null) {
      this.setState(prevState => ({
        range: prevState.range, // keep whatever was last
        fromMonth: prevState.range.from,
        toMonth: prevState.range.to || prevState.range.from,
        isActive: this.props.isActive
      }));
    }
  }

  onShownDateChange = (DateRange, calendar) => {
    const { defaultInceptionDateToggle } = this.state;
    const { handleSelect } = this.props;
    if (defaultInceptionDateToggle) {
      DateRange.range1.startDate = this.inceptionDate;
      DateRange.range1.endDate = isAfter(
        DateRange.range1.endDate,
        DateRange.range1.startDate
      )
        ? DateRange.range1.endDate
        : DateRange.range1.startDate;
    }

    this.setState(
      {
        ranges: [DateRange.range1]
      },
      () => {
        // typeof handleSelect === "function" && handleSelect(DateRange.range1);
      }
    );
  };

  onSubmit = () => {
    const { ranges, range } = this.state;

    const { onSubmit } = this.props;
    // typeof onSubmit === "function" && onSubmit(ranges[0]);
    typeof onSubmit === "function" && onSubmit(range, this.state.isActive);
  };

  onClose = () => {
    const { handleClose, selectedDate, isActive, fromToDate } = this.props;

    typeof handleClose === "function" && handleClose(null);

    const fromMonth = !isEmpty(fromToDate)
      ? new Date(fromToDate.start)
      : new Date();

    const toMonth =
      fromToDate && fromToDate.end != null
        ? new Date(fromToDate.end)
        : fromMonth.start != null
        ? new Date(fromMonth.start)
        : new Date(fromMonth.getFullYear(), fromMonth.getMonth() + 1);

    if (!isEmpty(fromToDate)) {
      this.setState({
        range: {
          from: fromToDate.start ? fromToDate.start : new Date(),
          to:
            fromToDate && fromToDate.end
              ? fromToDate.end
              : fromToDate && fromToDate.start
              ? fromToDate.start
              : new Date(),
          enteredTo: null
        },
        fromMonth: fromMonth,
        toMonth: toMonth,
        isActive: isActive
      });
    } else {
      this.setState({
        range: {
          from: new Date(),
          to: new Date(),
          enteredTo: null
        },
        fromMonth: fromMonth,
        toMonth: toMonth
      });
    }
  };

  isSelectingFirstDay(from, to, day) {
    const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
    const isRangeSelected = from && to;
    return !from || isBeforeFirstDay || isRangeSelected;
  }

  handleDayClick = (day, modifiers) => {
    const { range } = this.state;
    if (modifiers.disabled) return;
    this.props.resetPendingActive();
    this.setState({ isActive: "" });

    if (!range.from || (range.from && range.to)) {
      // Start new range
      this.setState({
        range: { from: day, to: null },
        fromMonth: day,
        toMonth: new Date(day.getFullYear(), day.getMonth() + 1)
      });
    } else if (day < range.from) {
      // Restart if selected before 'from'
      this.setState({
        range: { from: day, to: range.from }
      });
    } else {
      // Set 'to' date
      this.setState({
        range: { from: range.from, to: day }
      });
    }
  };

  handleDayMouseEnter(day) {
    const { from, to } = this.state.range;
    if (!this.isSelectingFirstDay(from, to, day)) {
      this.setState({
        enteredTo: day
      });
    }
  }

  handleYearMonthChange(month) {
    this.setState({ month: month });
  }

  handleFromMonthChange = month => {
    this.setState({ fromMonth: month });
  };

  handleToMonthChange = month => {
    this.setState({ toMonth: month });
  };

  render() {
    if (!this.props.show) return null;
    const {
      props: { show, handleClose, isAgendaList },
      state: { ranges, range, defaultInceptionDateToggle },
      onSubmit,
      onShownDateChange
    } = this;

    // parse date
    const startDay = ranges ? dateFormat(ranges[0].startDate) : null;
    const endDay = ranges ? dateFormat(ranges[0].endDate) : null;

    const { from, to, enteredTo } = range;
    const isSameMonth =
      range.from &&
      range.to &&
      range.from.getMonth() === range.to.getMonth() &&
      range.from.getFullYear() === range.to.getFullYear();
    const orgPath = window.location.pathname;
    const user = getLocalstorage("groupCategory");

    return (
      <div
        ref={this.wrapperRef}
        className={`datePicker-overlay ${show ? "visible" : ""}`}
        onClick={e => e.stopPropagation()}
      >
        <div
          className={`calendar-dropdown ${
            orgPath == "/dashboard" ? "dashboard" : ""
          }`}
          style={{
            width: "662px",
            fontFamily: "mpr",
            color: "black",
            lineHeight: "normal"
          }}
        >
          <div
            className="select-date-range"
            style={{
              background: "#FFF",
              display: "flex",
              // width: "fit-content",
              borderTopLeftRadius: "5px",
              borderTopRightRadius: "5px"
            }}
          >
            <div className="left-menu-datepicker">
              {this.props.calenderOptions.map((option, index) => {
                return option.value ? (
                  <div
                    key={index}
                    onClick={e => {
                      this.props.changSort(option);
                    }}
                    className={`hover-box ${
                      (this.props.pendingActive || this.state.isActive) ===
                      option.title
                        ? "active"
                        : ""
                    }`}
                  >
                    <span
                      style={{
                        color:
                          option.title == "Since Inception" ? "#E03655" : "",
                        fontWeight:
                          option.title == "Since Inception" ? "600" : ""
                      }}
                    >
                      {option.title}
                    </span>
                  </div>
                ) : null;
              })}
            </div>
            <div>
              <div style={{ display: "flex" }}>
                <div className="fromToDatePick">
                  {(from && formatCustomDate(from)) || (
                    <span style={{ color: "#B9B9B9" }}>From Date</span>
                  )}
                </div>
                <span
                  style={{ position: "absolute", left: "390px", top: "22px" }}
                >
                  <img src={rightArrow} alt="" />
                </span>
                <div className="fromToDatePick">
                  {(to && formatCustomDate(to)) || (
                    <span style={{ color: "#B9B9B9" }}>To Date</span>
                  )}
                </div>
              </div>
              <DayPicker
                className="Selectable-from"
                fromMonth={new Date(1925, 0)}
                toMonth={
                  this.props.tillYear
                    ? new Date(new Date().getFullYear(), 11)
                    : new Date(2099, 11)
                }
                selectedDays={[
                  range.from,
                  range.to ? { from: range.from, to: range.to } : null
                ]}
                disabledDays={[{ after: this.props.disabledDays }]}
                month={this.state.fromMonth}
                onDayClick={this.handleDayClick}
                onMonthChange={month => this.setState({ fromMonth: month })}
                modifiers={{
                  start: this.state.range.from,
                  end: isSameMonth ? range.to : null
                }}
                captionElement={({ date, localeUtils }) => (
                  <YearMonthFrom
                    date={this.state.fromMonth}
                    localeUtils={localeUtils}
                    onChange={this.handleFromMonthChange}
                    tillYear={this.props.tillYear}
                  />
                )}
                navbarElement={props => {
                  const { previousMonth, nextMonth, month } = props;

                  const isPrevDisabled =
                    range.from && month < new Date(1925, 1);
                  const toMonthLimit = this.props.tillYear
                    ? new Date(new Date().getFullYear(), 11)
                    : new Date(2099, 11);
                  const isNextDisabled = month >= toMonthLimit;

                  return (
                    <div className="DayPicker-NavBar">
                      <button
                        className={`DayPicker-NavButton DayPicker-NavButton--prev 
                          ${
                            window.location.pathname == "/create-agenda"
                              ? "create-agenda-top"
                              : ""
                          }`}
                        onClick={() => {
                          if (!isPrevDisabled) {
                            this.setState({ fromMonth: previousMonth });
                          }
                        }}
                        disabled={isPrevDisabled}
                        style={{
                          opacity: isPrevDisabled ? 0.5 : 1,
                          cursor: isPrevDisabled ? "default" : "pointer",
                          border: "none",
                          backgroundColor: "white"
                        }}
                      />
                      <button
                        className={`DayPicker-NavButton DayPicker-NavButton--next 
                          ${
                            window.location.pathname == "/create-agenda"
                              ? "create-agenda-top"
                              : ""
                          }`}
                        disabled={isNextDisabled}
                        onClick={() => {
                          if (!isNextDisabled) {
                            this.setState({ fromMonth: nextMonth });
                          }
                        }}
                        style={{
                          opacity: isNextDisabled ? 0.5 : 1,
                          cursor: isNextDisabled ? "default" : "pointer",
                          border: "none",
                          backgroundColor: "white"
                        }}
                      />
                    </div>
                  );
                }}
              />

              <DayPicker
                className="Selectable-to"
                fromMonth={new Date(range.from.getMonth() + 1, 1)}
                toMonth={
                  this.props.tillYear
                    ? new Date(new Date().getFullYear(), 11)
                    : new Date(2099, 11)
                }
                selectedDays={
                  range.from &&
                  range.to &&
                  (range.from.getMonth() !== range.to.getMonth() ||
                    range.from.getFullYear() !== range.to.getFullYear())
                    ? [{ from: range.from, to: range.to }]
                    : []
                }
                disabledDays={[
                  range.from
                    ? {
                        before: new Date(
                          range.from.getFullYear(),
                          range.from.getMonth() + 1,
                          1
                        )
                      }
                    : undefined,
                  this.props.disabledDays
                    ? { after: this.props.disabledDays }
                    : undefined
                ]}
                month={this.state.toMonth}
                onDayClick={this.handleDayClick}
                onMonthChange={month => this.setState({ toMonth: month })}
                modifiers={{
                  start: null,
                  // end: this.state.range.to,
                  end: range.to && !isSameMonth ? range.to : null
                }}
                captionElement={({ date, localeUtils }) => (
                  <YearMonthFrom
                    date={this.state.toMonth}
                    localeUtils={localeUtils}
                    onChange={this.handleToMonthChange}
                    tillYear={this.props.tillYear}
                  />
                )}
                navbarElement={props => {
                  const { previousMonth, nextMonth, month } = props;

                  const isPrevDisabled =
                    range.from &&
                    month <=
                      new Date(
                        range.from.getFullYear(),
                        range.from.getMonth() + 2,
                        1
                      );
                  const toMonthLimit = this.props.tillYear
                    ? new Date(new Date().getFullYear(), 11)
                    : new Date(2099, 11);
                  const isNextDisabled = month >= toMonthLimit;

                  return (
                    <div className="DayPicker-NavBar">
                      <button
                        className={`DayPicker-NavButton DayPicker-NavButton--prev 
                          ${
                            window.location.pathname == "/create-agenda"
                              ? "create-agenda-top"
                              : ""
                          }`}
                        onClick={() => {
                          if (!isPrevDisabled) {
                            this.setState({ toMonth: previousMonth });
                          }
                        }}
                        disabled={isPrevDisabled}
                        style={{
                          opacity: isPrevDisabled ? 0.5 : 1,
                          cursor: isPrevDisabled ? "default" : "pointer",
                          border: "none",
                          backgroundColor: "white"
                        }}
                      />
                      <button
                        className={`DayPicker-NavButton DayPicker-NavButton--next 
                          ${
                            window.location.pathname == "/create-agenda"
                              ? "create-agenda-top"
                              : ""
                          }`}
                        disabled={isNextDisabled}
                        onClick={() => {
                          if (!isNextDisabled) {
                            this.setState({ toMonth: nextMonth });
                          }
                        }}
                        style={{
                          opacity: isNextDisabled ? 0.5 : 1,
                          cursor: isNextDisabled ? "default" : "pointer",
                          border: "none",
                          backgroundColor: "white"
                        }}
                      />
                    </div>
                  );
                }}
              />
            </div>
          </div>
          {/* <div className="daterange-footer">
            <Form.Group className="checkbox" controlId="formBasicCheckbox2">
              <Form.Check
                type="checkbox"
                onClick={() => {
                  onChangeDefaultDate("defaultInceptionDateToggle");
                }}
                label="Inception Date"
                checked={defaultInceptionDateToggle}
              />
            </Form.Group>
            <div className="daterange-footer-dates">
              <div className="dates-wrapper">
                <div className="from-date">
                  <label>From Date</label>
                  <span>{startDay}</span>
                </div>
                <div className="to-date">
                  <label>To Date</label>
                  <span>{endDay}</span>
                </div>
              </div>
              <div className="dates-wrapper">
                <Button className="btn-white" onClick={onSubmit}>
                  Submit
                </Button>
                <Button className="btn-sky-blue" onClick={handleClose}>
                  Cancel
                </Button>
              </div>
            </div>
          </div> */}
          <div className="footer-datepicker daterange-footer">
            <div className="dates-wrapper">
              <Button
                className="btn-orange-invert no-padding btn-cancel"
                onClick={this.onClose}
              >
                CANCEL
              </Button>
              <Button
                className="btn-orange no-padding small-height create-btn"
                onClick={onSubmit}
              >
                APPLY
              </Button>
            </div>
          </div>
          <Helmet>
            <style>{`
.Selectable-from .DayPicker-Day--outside,
.Selectable-to .DayPicker-Day--outside {
  background: none !important;
  color: inherit !important;
  border-radius: 0 !important;
  pointer-events: none; /* optional - prevents hover/click */
}

.Selectable-from .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside),
.Selectable-to .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
    background-color: #303f9f !important;
    color: white;
  }
  .Selectable-from .DayPicker-Day,
  .Selectable-to .DayPicker-Day {
    border-radius: 0 !important;
    font-weight: 400;
    font-size: 13px;
  }
  .Selectable-from .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside),
  .Selectable-to .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
  background-color: #EBEBEB !important;
  color: black !important;
}
  .Selectable-from .DayPicker-Day--start:not(.DayPicker-Day--outside),
  .Selectable-to .DayPicker-Day--start:not(.DayPicker-Day--outside) {
    background-color: #303f9f !important;
    border-top-left-radius: 50% !important;
    border-bottom-left-radius: 50% !important;
  }
  .Selectable-from .DayPicker-Day--end:not(.DayPicker-Day--outside),
  .Selectable-to .DayPicker-Day--end:not(.DayPicker-Day--outside){
    background-color: #303f9f !important;
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }
  
`}</style>
          </Helmet>
        </div>
      </div>
    );
  }
}

// export default enhanceWithClickOutside(PMIICDateRangePicker);
export default PMIICDateRangePicker;
